import feather from 'feather-icons'
import React, { useContext, useEffect, useState } from 'react'
import ApiRequest from '../Common/restservice';
import { errorToast } from '../Common/showtoast';
import { useNavigate } from 'react-router-dom';
import ProfileModal from './ProfileModal';
import ThemeContext from '../themecontext';

function Header() {
    const { theme, setTheme } = useContext(ThemeContext);
    const [showProfile, setShowProfile] = useState(false);
    const [stateObj, setStateObj] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
        feather.replace();
        const GetProfileDetails = async () => {
            let res = await ApiRequest("MyProfile.asp", "GET", null, { Authorization: localStorage.getItem("token") });
            if (res.status === "error") {
                errorToast(res.message);
                if (res.message === "Session Expired") {
                    localStorage.clear();
                    navigate("/login");
                }
                return;
            }
            setStateObj(res);
        }
        GetProfileDetails();
    }, [])
    return (
        <> <header className="main-header">
            <div className="d-flex align-items-center logo-box justify-content-start">
                <a href="#" className="logo">
                    <div className="logo-mini w-40">
                        <span className="light-logo"><img src={require('../Assets/Images/logoicon.png')} alt="logo" /></span>
                        <span className="dark-logo"><img src={require('../Assets/Images/logoicon.png')} alt="logo" /></span>
                    </div>
                    <div className="logo-lg">
                        <span className="light-logo"><img className='h-auto' src={require('../Assets/Images/logo.png')} alt="logo" /></span>
                        <span className="dark-logo"><img className='h-auto' src={require('../Assets/Images/logo.png')} alt="logo" /></span>
                    </div>
                </a>
            </div>
            <nav className="navbar navbar-static-top">
                <div className="app-menu">
                    <ul className="header-megamenu nav">
                        <li className="btn-group nav-item">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                if (window.innerWidth > 720)
                                    document.body.classList.toggle('sidebar-collapse');
                                else
                                    document.body.classList.toggle('sidebar-open');
                            }} className="waves-effect waves-light nav-link push-btn btn-primary-light" data-toggle="push-menu" role="button">
                                <i data-feather="menu"></i>
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="navbar-custom-menu r-side">
                    <ul className="nav navbar-nav">
                        <li className="dropdown notifications-menu btn-group">
                            <label className="switch">
                                <a onClick={(e) => {
                                    e.preventDefault();
                                    if (document.body.classList.contains('light-skin')) {
                                        document.body.classList.remove('light-skin');
                                        document.body.classList.add('dark-skin');
                                        sessionStorage.setItem('theme', "dark");
                                        setTheme("dark");
                                    } else {
                                        sessionStorage.setItem('theme', "light");
                                        document.body.classList.add('light-skin');
                                        document.body.classList.remove('dark-skin');
                                        setTheme("light");
                                    }
                                }} className="waves-effect waves-light btn-primary-light svg-bt-icon">
                                    <input type="checkbox" data-mainsidebarskin="toggle" id="toggle_left_sidebar_skin" />
                                    <span className="switch-on"><i data-feather="moon"></i></span>
                                    <span className="switch-off"><i data-feather="sun"></i></span>
                                </a>
                            </label>
                        </li>
                        <li className="dropdown notifications-menu btn-group align-items-center">
                            <label className="switch badge badge-primary mx-2">
                                {stateObj.fullname} ({stateObj.username})
                            </label>
                        </li>
                        <li className="dropdown user user-menu">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setShowProfile(!showProfile);
                            }} className="waves-effect waves-light dropdown-toggle w-auto l-h-12 bg-transparent p-0 no-shadow" title="User" data-bs-toggle="modal" data-bs-target="#quick_user_toggle">
                                <img src={require('../Assets/Images/man.png')} className="avatar rounded-circle bg-primary-light h-40 w-40" alt="" />
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>

            <ProfileModal showProfile={showProfile} setShowProfile={setShowProfile} />
        </>

    )
}

export default Header